import { ValueOf } from 'common/types'

export const BASE_API_URL = '/api'

export const HttpCode = {
  Ok: 200,
  NoContent: 204,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  UnprocessableEntity: 422,
  UnavailableLegalReasons: 451,
  InternalServerError: 500,
}

export type HttpCode = ValueOf<typeof HttpCode>
